import { httpService as n } from "@waitroom/http-client";
import { config as s } from "../config.es.js";
const l = `
  _id,
  type,
  hero,
  cta,
  vertical,
  horizontal,
  grid,
  testimonials,
  blockList,
  features,
  pricing,
  faq,
  compareTable,
  investors
`, c = `
  _id,
  title,
  description,
  slug,
  url,
  image,
  category,
  type,
  menuTitle,
  menuIcon,
  menuOrder,
  hideHeaderMenu
`, a = `
  ${c},
  sections
`, d = {
  getPage: async (t, e) => {
    var i, o;
    const r = await n.get({
      ...e,
      url: s.sanityUrl,
      params: {
        ...e == null ? void 0 : e.params,
        query: `*[_type == "page" && slug.current == "${t}"]{
          ${a},
          sections[] {
            ...,
            section->{
              ${l}
            }
          }
        }`
      },
      throwError: !1,
      withCredentials: !0
    });
    if (((o = (i = r.data) == null ? void 0 : i.result) == null ? void 0 : o.length) === 0) throw Error("Nothing found");
    return r;
  },
  getPages: async (t, e) => n.get({
    ...e,
    url: s.sanityUrl,
    params: {
      ...e == null ? void 0 : e.params,
      query: `*[_type == "page"${t != null && t.length ? ` && (${t.map((r) => `type == "${r}"`).join(" || ")})` : ""}]{${c}}|order(category desc, menuOrder asc)`
    },
    throwError: !1,
    withCredentials: !0
  })
};
export {
  d as cmsApiService
};
